module.exports = __webpack_public_path__ + "static/media/img22.14f676c4.jpg";